import { useAuth } from '../contexts/AuthContext';
import { TransactionNotifications } from '../lib/notifications';
import { supabase } from '../lib/supabase';

export function useEmailNotifications() {
  const { user } = useAuth();

  const sendNewTransactionNotification = async (transactionId: string) => {
    try {
      // Récupérer les détails de la transaction
      const { data: transaction, error } = await supabase
        .from('transactions')
        .select(`
          property_number,
          seller,
          buyer,
          sale_price,
          created_by,
          transaction_agencies (
            agency
          ),
          transaction_negotiators (
            negotiator:negotiators (
              firstname,
              lastname
            )
          )
        `)
        .eq('id', transactionId)
        .single();

      if (error) throw error;

      // Utiliser le nouveau service de notifications
      await TransactionNotifications.notifyNewTransaction(transactionId, {
        property_number: transaction.property_number,
        seller: transaction.seller,
        buyer: transaction.buyer,
        sale_price: transaction.sale_price,
        agencies: transaction.transaction_agencies.map(ta => ta.agency),
        negotiators: transaction.transaction_negotiators
          .map(tn => `${tn.negotiator.firstname} ${tn.negotiator.lastname}`),
        created_by: transaction.created_by
      });
      
      console.log('New transaction notifications sent successfully');
    } catch (error) {
      console.error('Error sending new transaction notifications:', error);
    }
  };

  const sendStatusChangeNotification = async (
    transactionId: string, 
    oldStatus: string, 
    newStatus: string
  ) => {
    try {
      // Utiliser le nouveau service de notifications
      await TransactionNotifications.notifyStatusChange(transactionId, oldStatus, newStatus);
      console.log('Status change notifications sent successfully');
    } catch (error) {
      console.error('Error sending status change notifications:', error);
    }
  };

  const sendRegularizationNotification = async (transactionId: string, comment: string) => {
    try {
      // Utiliser le nouveau service de notifications
      if (!user?.id) {
        throw new Error('User not found');
      }
      
      await TransactionNotifications.notifyRegularizationRequest(transactionId, user.id, comment);
      console.log('Regularization notifications sent successfully');
    } catch (error) {
      console.error('Error sending regularization notifications:', error);
    }
  };

  const sendRegularizationApprovalNotification = async (
    transactionId: string,
    approved: boolean,
    adminComment?: string
  ) => {
    try {
      // Utiliser le nouveau service de notifications
      if (!user?.id) {
        throw new Error('User not found');
      }
      
      await TransactionNotifications.notifyRegularizationApproval(
        transactionId, 
        approved, 
        user.id, 
        adminComment
      );

      console.log('Regularization approval notification sent successfully');
    } catch (error) {
      console.error('Error sending regularization approval notification:', error);
    }
  };

  return {
    sendNewTransactionNotification,
    sendStatusChangeNotification,
    sendRegularizationNotification,
    sendRegularizationApprovalNotification
  };
}